import { useMemo } from 'react';
import { useTracks } from '@livekit/components-react';
import { Track } from 'livekit-client';

/**
 * True when at least one remote LiveKit identity is still in the room.
 * Camera-off (placeholder tile) still counts as present — only identity
 * departure is "gone".
 *
 * Must only be called under a LiveKit room provider.
 */
export function useOneToOneRemotePeerPresent(): boolean {
  const cameraTracks = useTracks(
    [{ source: Track.Source.Camera, withPlaceholder: true }],
    { onlySubscribed: true },
  );

  return useMemo(
    () => cameraTracks.some((track) => !track.participant.isLocal),
    [cameraTracks],
  );
}
